// Import Parts Conversational
import processMonetique from "./parts/process-monetique";
import processDemande from "./parts/process-demandes";
import formStandard from "./parts/form-tmb-standard";

export const form_flow = [
    {
        'tag': 'cf-robot-message',
        'type': 'text',
        'name': 'welcome',
        'cf-questions': 'Bienvenue au service client de votre Banque !',
    },
    {
        'tag': 'select',
        'type': 'text',
        'name': 'category',
        'cf-questions': 'Choisissez la categorie de la requête ?',
        "children": [
            {
                "tag": "option",
                "cf-label": "Réclamation",
                "value": "category_reclamation",
            },
            {
                "tag": "option",
                "cf-label": "Demandes",
                "value": "category_tmb_demandes",
            },
        ]
    },

    ...processMonetique,
    ...processDemande,
    ...formStandard,
]
